import { useState,useEffect,useCallback } from "react";
import AxiosFetchData from "../pages/AxiosFetchData";
import { useNavigate, useParams } from 'react-router-dom';
import ConfirmationButton from '../components/ConfirmationButton';
import Helper from "../pages/Helper";
import React  from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import DatePicker from 'react-datepicker'; 
import Select, { SelectChangeEvent } from '@mui/material/Select';
import axios from "axios";
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { darken, lighten } from '@mui/material/styles';
import {apiUrl} from '../pages/UrlParam'; 
import { CatchWrapperAsync } from "../utils/catchwrapper";

export const useListPOHook = () =>{
    const [project, setProject] = useState({});
    const [confirmDelegasiOpen, setConfirmDelegasiOpen] = useState('');
    const [levelList, setLevelList] = useState([]);
    const [prioritasList, setPrioritasList] = useState([]);
    const Navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [rowsDelegasi, setRowsDelegasi] = useState([]);
    const [user, setUser] = useState({});
    const [anchorEl, setAnchorEl] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedData, setSelectedData] = useState({});
    const [message, setmessage] = useState('');
    const [tipe, settipe] = useState('');
    const [roleAccess, setRoleAccess] = useState('');
    const open = Boolean(anchorEl);
    const [sortModel, setsortModel] = useState({})
    const [filterModel, setFilterModel] = useState({
        items: [],
        quickFilterExcludeHiddenColumns: true,
        quickFilterValues: [''],
      });

    const paging = {
        page: 0,
        pageSize: 10,
    }

     var search=null;
      var sort = null;
      const [paginationModel, setPaginationModel] = useState(paging);
      const onPaginationModelChange = useCallback((pagingModel) => {
        pagingModel.filterModel = search;
        pagingModel.sortModel = sort;
        setPaginationModel(pagingModel);
      },[]);
    
      const onFilterChange = React.useCallback((filterModel) => {
       
         setFilterModel({ ...filterModel } );
         search = { ...filterModel};
         paging.filterModel = { ...filterModel };
         setPaginationModel(paging);
      },[]);
    
      const handleSortModelChange = useCallback((sortModel) => {
     
        setsortModel(sortModel);
        paging.sortModel = { ...sortModel };
        sort = { ...sortModel };
        setPaginationModel(paging);
      }, []);
    
      const [rowCountState, setRowCountState] = useState(0);
    
      const handleClick = (event,data) => {
        //alert(id)
        setSelectedData(data)
        setAnchorEl(event.currentTarget);
      };
    
    
      const handleClose = () => {
        setAnchorEl(null);
      };

       useEffect(() => {
          GetLevel();
          GetPrioritas();
          fetchData(); 
           
            
        }, [paginationModel,filterModel,sortModel]);

    const fetchData = async () => {
        CatchWrapperAsync(async ()=>{
            const response = await AxiosFetchData.get("GetListPO", paginationModel).refreshToken(Navigate,"projectpm");
            setRoleAccess(response.roleaccess)
            setUser(response.decode);
            if(response){
              setRowCountState(response.data.count[0].counts)
              const rowsWithRowNumbers = response.data.data.map((row, index) => ({
                ...row,
                rowNumber: index + 1, 
                }));
               setRows(rowsWithRowNumbers);
            }
        },setmessage,settipe)
        
    };
 
      
      const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({id:false});

      const LevelList = ({data}) => {
    
        return (
            <FormControl fullWidth>
            <Select
            //value={data.id_level}
            value={data.levelid}
            id="demo-multiple-name"
             labelId="demo-simple-select-label"
            //value={personName}
             label="Level"
             disabled={!roleAccess.UPDATE}
            onChange={(evt) => handleSelectedLevel(evt, data)}
           // input={<OutlinedInput label="Name" />}
           // MenuProps={MenuProps}
          >
            {levelList.map((name) => (
              <MenuItem
                key={name.value}
                value={name.value}
                
              >
                {name.label}
              </MenuItem>
            ))}
          </Select>
      </FormControl>
        );
      };
      
      const PrioritasList = ({data}) => {
        
        return (
            <FormControl fullWidth>
            <Select
           value={data.id_prioritas}
            id="demo-multiple-name"
             labelId="demo-simple-select-label"
            //value={personName}
             label="Prioritas"
             disabled={!roleAccess.UPDATE}
            onChange={(evt) => handleSelectedPrioritas(evt, data)}
           // input={<OutlinedInput label="Name" />}
           // MenuProps={MenuProps}
          >
            {prioritasList.map((name) => (
              <MenuItem
                key={name.value}
                value={name.value}
                
              >
                {name.label}
              </MenuItem>
            ))}
          </Select>
      </FormControl>
        );
      };
    
      const ProjectStart = ({data}) => {
        return (<DatePicker 
            showIcon
            selected={data.tanggal_mulai == "0000-00-00" ? null : (data.tanggal_mulai ? new Date(data.tanggal_mulai) : null)}
            onChange={(date) => handleSelectedStartDate(date, data)}
            disabled={!roleAccess.UPDATE}
            fontSize={8}
            dateFormat="dd-MM-yyyy"
            className="form-control"/>)
      }
    
      const ProjectEnd = ({data}) => {
            return (<DatePicker 
                showIcon
                selected={data.tanggal_selesai == "0000-00-00" ? null : (data.tanggal_selesai ? new Date(data.tanggal_selesai) : null)}
                onChange={(date) => handleSelectedEndDate(date, data)}
             
                disabled={!roleAccess.UPDATE}
                dateFormat="dd-MM-yyyy"
                className="form-control"/>)
            }

    const columns = [
      { field: 'rowNumber', headerName: 'No.', width: 50  ,sortable: false ,},
      {
        field: 'actions',
        headerName: 'Actions',
        width: 100,
        sortable: false ,
        renderCell: (params) => (
          <>
               
     <Button
            id={"basic-button" + params.row.rowNumber}
            aria-controls={open ? 'basic-menu' + params.row.rowNumber : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={(evt) => handleClick(evt, params.row)}
          >
            <MoreVertIcon sx={{ fontSize: 30 }}/>
          </Button>
     
          <Menu
          PaperProps={{
                    sx: {
                      boxShadow: (theme) => theme.shadows[2],
                    }
                  }}
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <MenuItem    onClick={() => handleEdit(selectedData)} >DETAIL</MenuItem>
            <MenuItem    disabled={!roleAccess.UPDATE} onClick={() => handleDelete(selectedData)} >DELEGATION</MenuItem>
            <MenuItem    onClick={() => Navigate('/RAK/' + selectedData.id + '?ReturnUrl=ListPO')} >RAK</MenuItem>
            <MenuItem    onClick={() => Navigate('/InvoiceListV3/' + selectedData.id + '?ReturnUrl=ListPO')} >INVOICES</MenuItem>
          </Menu>
         
          {/* <button
              onClick={() => handleEdit(params.row)} // Pass the project ID to the edit function
              className="btn btn-primary mr-2"
             >
              Details
            </button> */}
    
          </>
          
        ),
    
    
        
      },
    { field: 'id', headerName: 'ID', width: 150,hideable: true  },
      // { field: 'quotation_id', headerName: 'Quotation ID', width: 150,hideable: true   },
    { field: 'po_date', headerName: 'PO Date', width: 100 },
    { field: 'po_no', headerName: 'PO No.', width: 250 },
    { field: 'quotation_id', headerName: 'Quot No.', width: 200 },
    { field: 'subject', headerName: 'Name', width: 250 },
    { field: 'name', headerName: 'Customer', width: 300 },
    { field: 'totalpo', headerName: 'Value', width: 130, valueGetter:({ value }) => value && Helper.formatAsCurrency(value) },
    { field: 'faktur', headerName: 'Payment', width: 120, valueGetter:({ value }) => value && Helper.formatAsCurrency(value) },
    { field: 'anggaran_tersisa', headerName: 'Remaining Debt', width: 150 , valueGetter:({ value }) => value && Helper.formatAsCurrency(value)},
    { field: 'nama_client', headerName: 'Delegation', width: 150 },
    
      {
        field: 'actions2',
        headerName: 'Level',
        width: 120,
        sortable: false ,
        renderCell: (params) => <LevelList data={params.row}/>,
      },
      {
        field: 'actions3',
        headerName: 'Prioritas',
        width: 120,
        sortable: false ,
        renderCell: (params) => <PrioritasList data={params.row}/>,
      },
      {
        field: 'actions4',
        headerName: 'Start',
        width: 125,
        sortable: false ,
        renderCell: (params) => <ProjectStart data={params.row}/>,
      },
      {
        field: 'actions5',
        headerName: 'End',
        width: 125,
        sortable: false ,
        renderCell: (params) => <ProjectEnd data={params.row}/>,
      },
     
    ];
    
    const columnsDelegasi = [
        { field: 'rowNumber', headerName: 'No.', width: 80 },
        { field: 'nama_client', headerName: 'ID', width: 200 },
        {
          field: 'actions',
          headerName: 'Actions',
          width: 170,
          renderCell: (params) => (
            <>
                <ConfirmationButton classname='btn btn-primary mr-2' text="Do you want choose this data?" type="button" onClick={() => handleDelegasi(params.row.id)}>
                   Pilih
                </ConfirmationButton>
            </>
            
          ),
      
      
          
        },
      
      ];
     

    const handleDelete = async (data) => {
        setAnchorEl(false);
        setProject(data)
        setConfirmDelegasiOpen(true);

        CatchWrapperAsync(async ()=>{
            const response = await AxiosFetchData.get("GetDelegasi").refreshToken(Navigate,"projectpm",true);
            if(response){
                setRowsDelegasi(response.data); 
            }
        },setmessage,settipe)
    };
    
    const handleEdit = async (data) => {
        CatchWrapperAsync(async ()=>{
            Navigate(`/AddPO/${data.id}/${data.id}/DetailAll${Helper.SetReturnUrl()}`)
        },setmessage,settipe)
    };

    function handleSelectedLevel(event, data){
        var data = {
             nama_project: data.subject,
             id_client : data.customer_id,
             id_level : event.target.value,
             id_project : data.id,
             alias_project : data.subject
        }
        
        AddProject(data);
    }

     async function handleSelectedPrioritas(event, data){
      
         var data = {
             nama_project: data.subject,
            // id_resource:data,
             id_client : data.customer_id,
             //anggaran : 5000000,
            // tanggal_mulai : '2024-01-01',
            // tanggal_selesai : '2024-01-01',
            // id_level : event.target.value,
             id_project : data.id,
             id_prioritas:event.target.value,
             alias_project : data.subject
        }
       // console.log(data)
        AddProject(data);
     }
     
     async function handleSelectedStartDate(event, data){
       var data = {
           nama_project: data.subject,
          // id_resource:data,
           id_client : data.customer_id,
           //anggaran : 5000000,
           tanggal_mulai : event,
          // tanggal_selesai : '2024-01-01',
          // id_level : event.target.value,
           id_project : data.id,
          alias_project : data.subject
          //id_prioritas:event.target.value,
      }
     
       AddProject(data);
     }
     
     async function handleSelectedEndDate(event, data){
       var data = {
            nama_project: data.subject,
            id_client : data.customer_id,
            tanggal_selesai : event,
            id_project : data.id,
            alias_project : data.subject
        }
     
        AddProject(data);
     }
     
     async function handleDelegasi(id){
          
         var data = {
             nama_project: project.subject,
             id_resource:id,
             id_client : project.customer_id,
             id_project : project.id,
             assigned_by : user.userID,
             alias_project : project.subject
        }

        AddProject(data)
        setConfirmDelegasiOpen(false);
     }
     
     
    async function AddProject(data){
        CatchWrapperAsync(async ()=>{
            const response = await AxiosFetchData.post(`AddProject`, data).refreshToken(Navigate,"projectpm");
            if(response){
                fetchData();
                setIsOpen(true)
                setmessage(response.data)
            }
        },setmessage,settipe)
    }

     function GetLevel(){
         axios.get(`${apiUrl}/api/GetLevel`)
         .then((response) => {
           const transformedOptions = response.data.map((item) => ({
             label: `${item.id} - ${item.name}`,
             value: item.id,
           }));
            setLevelList(transformedOptions);
           //return transformedOptions;
         })
         .catch((error) => {
           console.error('Error fetching category data:', error);
         });
          
     }
     
     function GetPrioritas(){
         axios.get(`${apiUrl}/api/GetPrioritas`)
         .then((response) => {
           const transformedOptions = response.data.map((item) => ({
             label: `${item.id} - ${item.name}`,
             value: item.id,
           }));
            setPrioritasList(transformedOptions);
          
         })
         .catch((error) => {
           console.error('Error fetching category data:', error);
         });
          
     }
     
     const getBackgroundColor = (color, mode) =>
       mode === 'dark' ? darken(color, 0.6) : lighten(color, 0.6);
     
     const getHoverBackgroundColor = (color, mode) =>
       mode === 'dark' ? darken(color, 0.5) : lighten(color, 0.5);

     return {message,setmessage,tipe,settipe,getBackgroundColor,getHoverBackgroundColor,columns,rows,rowCountState,paginationModel,onPaginationModelChange,onFilterChange,filterModel,handleSortModelChange,columnVisibilityModel,setColumnVisibilityModel,confirmDelegasiOpen,setConfirmDelegasiOpen,columnsDelegasi,rowsDelegasi}
     
     
}